import React from 'react';
import { translations } from '../translations';
import '../styles/pages/Privacy.css';

function Privacy({ language }) {
  const t = translations[language];

  return (
    <div className="privacy-page">
      <div className="privacy-hero">
        <h1>{t.privacyTitle}</h1>
        <p>{t.privacySubtitle}</p>
      </div>

      <div className="privacy-content">
        <section className="privacy-section">
          <h2>{t.privacyIntroTitle}</h2>
          <p>{t.privacyIntroText}</p>
        </section>

        <section className="privacy-section">
          <h2>{t.dataCollectionTitle}</h2>
          <p>{t.dataCollectionText}</p>
          <h3>{t.personalDataTitle}</h3>
          <ul>
            <li>{t.personalDataItem1}</li>
            <li>{t.personalDataItem2}</li>
            <li>{t.personalDataItem3}</li>
            <li>{t.personalDataItem4}</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>{t.dataUseTitle}</h2>
          <p>{t.dataUseText}</p>
          <ul>
            <li>{t.dataUseItem1}</li>
            <li>{t.dataUseItem2}</li>
            <li>{t.dataUseItem3}</li>
            <li>{t.dataUseItem4}</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>{t.dataSharingTitle}</h2>
          <p>{t.dataSharingText}</p>
        </section>

        <section className="privacy-section">
          <h2>{t.dataSecurityTitle}</h2>
          <p>{t.dataSecurityText}</p>
        </section>

        <section className="privacy-section">
          <h2>{t.userRightsTitle}</h2>
          <p>{t.userRightsText}</p>
          <ul>
            <li>{t.userRightsItem1}</li>
            <li>{t.userRightsItem2}</li>
            <li>{t.userRightsItem3}</li>
            <li>{t.userRightsItem4}</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>{t.contactPrivacyTitle}</h2>
          <p>{t.contactPrivacyText}</p>
          <p>
            Email: <a href="mailto:apps@dysorto.fr">apps@dysorto.fr</a>
          </p>
        </section>

        <p className="last-updated">{t.lastUpdated}</p>
      </div>
    </div>
  );
}

export default Privacy;
